<div class="modal">
  <div class="modal-content">
    <div class="headerModal">
      <h3>{{'stats.graphs.settings.addBtn'|translate}}</h3>
      <span class="close pointer" style="padding-left: 2em;" (click)="doClose()">
        <i aria-hidden="true" class="fad fa-times fa-1x5 primaryRed"></i>
      </span>
    </div>
    <div>
      <div>
        <mat-form-field>
          <mat-label>{{'stats.graphs.settings.name'|translate}}</mat-label>
          <mat-select (selectionChange)="changeSelection($event.value)">
            <mat-option *ngFor="let graph of graphsList; index as idx" [value]="idx">{{graph|translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="center">
        <button (click)="doSave()">{{'stats.graphs.settings.add'|translate}}</button>
      </div>
    </div>
  </div>
</div>
